import React, { useEffect } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Alert } from "reactstrap";

interface OrderStatusModalProps {
  isOpen: boolean;
  toggle: () => void;
  selectedStatus: string;
  setSelectedStatus: (status: string) => void;
  orderStatusLists: { id: string; name: string }[];
  handleStatus: () => void;
  currentStatus: string;
}
const OrderStatusModal: React.FC<OrderStatusModalProps> = ({
  isOpen,
  toggle,
  selectedStatus,
  setSelectedStatus,
  orderStatusLists,
  handleStatus,
  currentStatus,
}) => {
  const unchangeableStatuses = ["4", "8"];
  console.log("selectedStatus modal", selectedStatus)
  console.log("orderStatusLists modal", orderStatusLists)
  console.log("currentStatus modal", currentStatus)
  const statusFlow: Record<string, string[]> = {
    "1": ["2", "3"],
    "2": ["5"],
    "5": ["7"],
    "7": ["8"],
  };

  const isStatusUnchangeable = unchangeableStatuses.includes(currentStatus);
  console.log("isStatusUnchangeable", isStatusUnchangeable)
  const getAllowedStatuses = () => {
    if (isStatusUnchangeable) return [];
    return statusFlow[String(currentStatus)] || [];
  };

  const allowedStatuses = getAllowedStatuses();

  console.log("allowedStatuses", allowedStatuses)
  const isOptionDisabled = (statusId: string) => {
    if (isStatusUnchangeable) return true;
    // Enable if it's the current status or an allowed transition
    return !allowedStatuses.some(allowedId => String(allowedId) === String(statusId));
  };
  const handleSelectStatus = (statusId: string) => {
    if (isOptionDisabled(statusId)) return;
    setSelectedStatus(statusId);
  };

  const handleSubmit = async () => {
    try {
      await handleStatus();
      // Only close modal if updating to "Delivered" (status 8)
      if (String(selectedStatus) === "8") {
        toggle();
      }
    } catch (error) {
      console.error("Status update failed:", error);
    }
  };

  useEffect(() => {
    if (currentStatus) {
      const allowed = statusFlow[String(currentStatus)];
      if (allowed && allowed.length === 1) {
        setSelectedStatus(allowed[0]);
      } else {
        setSelectedStatus(currentStatus);
      }
    }
  }, [currentStatus]);

  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle}>Update Order Status</ModalHeader>
      <ModalBody>
        {isStatusUnchangeable && (
          <Alert color={currentStatus === "4" ? "secondary" : "success"}>
            {currentStatus == "4"
              ? "This order was cancelled by the user and cannot be updated."
              : "This order has already been delivered and cannot be updated."}
          </Alert>
        )}

        <div>
          <label className="form-label mb-2 d-block fw-bold">Order Status</label>
          <div className="d-flex flex-wrap gap-2">
            {orderStatusLists?.map((option) => {
              const isDisabled = isOptionDisabled(option.id);
              const isSelected = selectedStatus == option.id;
              const isCurrent = currentStatus == option.id;

              let bgColor = "#f8f9fa"; // default light background
              let textColor = "#000"; // default black text

              if (isDisabled) {
                bgColor = "#e0e0e0"; // light gray for disabled
                textColor = "#999"; // muted text
              } else if (!allowedStatuses.includes(option.id) && !isCurrent) {
                bgColor = "#f8d7da"; // light red for not allowed
                textColor = "#000";
              }

              if (isSelected) {
                bgColor = "#c3e6cb"; // light green (lighter than previous #28a745)
                textColor = "#000"; // white text
              }

              if (isCurrent && !isSelected) {
                bgColor = "#d1e7dd"; // soft green to show it's current but not selected
              }

              return (
                <div
                  key={option.id}
                  className="d-flex align-items-center justify-content-center"
                  style={{
                    width: "120px",
                    height: "40px",
                    backgroundColor: bgColor,
                    color: textColor,
                    borderRadius: "4px",
                    cursor: isDisabled ? "not-allowed" : "pointer",
                    border: "1px solid #ddd",
                    fontWeight: "bold",
                    textAlign: "center",
                  }}
                  onClick={() => handleSelectStatus(option.id)}
                >
                  {option.name}
                </div>
              );
            })}
          </div>
        </div>
      </ModalBody>
      <ModalFooter>
        <Button
          style={{
            border: "1px solid #ddd",
            fontWeight: "bold",
            backgroundColor: "#e2e3e5", // light gray
            color: "#383d41" // dark gray text
          }}
          onClick={toggle}
        >
          Close
        </Button>
        {!isStatusUnchangeable && (
          <Button
            className="btn btn-success w-sm"

            onClick={handleSubmit}
            disabled={String(selectedStatus) === String(currentStatus) || isOptionDisabled(selectedStatus)}
          >
            Update Status
          </Button>
        )}
      </ModalFooter>
    </Modal>
  );
};

export default OrderStatusModal;